const ROUTE = {
  LOADING: 'LOADING',
  LOGIN_MOBILE_NUMBER_SCREEN: 'LOGIN_MOBILE_NUMBER_SCREEN',
  LOGIN_OTP_SCREEN: 'LOGIN_OTP_SCREEN',
  DASHBOARD_SCREEN: 'DASHBOARD_SCREEN',
  INTEREST_CALCULATOR: 'INTEREST_CALCULATOR',
  FAQ: 'FAQ',
  TRANSACTION_SCREEN: 'TRANSACTION_SCREEN',
  MANAGE_LIMIT_SCREEN: 'MANAGE_LIMIT_SCREEN',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  ENTER_EMAIL: 'ENTER_EMAIL',
  KYC_PAN_VERIFICATION: 'KYC_PAN_VERIFICATION',
  BANK_ACCOUNT_VERIFICATION: 'BANK_ACCOUNT_VERIFICATION',
  BANK_SELECT: 'BANK_SELECT',
  BANK_ACCOUNT_ADD: 'BANK_ACCOUNT_ADD',
  BANK_BRANCH_SEARCH: 'BANK_BRANCH_SEARCH',
  NAME_MISMATCH: 'NAME_MISMATCH',
  KYC_DOCUMENTS: 'KYC_DOCUMENTS',
  KYC_DIGIO_RESPONSE: 'KYC_DIGIO_RESPONSE',
  KYC_DIGIO_REDIRECT: 'KYC_DIGIO_REDIRECT',
  KYC_PHOTO_VERIFICATION: 'KYC_PHOTO_VERIFICATION',
  KYC_PHOTO_MISMATCHH: 'KYC_PHOTO_MISMATCHH',
  KYC_ADDITIONAL_DETAILS: 'KYC_ADDITIONAL_DETAILS',
  KYC_SUMMARY: 'KYC_SUMMARY',
  SUPPORTING_DOCUMENT: 'SUPPORTING_DOCUMENT',
  DIGIO_MANDATE_SIGN: 'DIGIO_MANDATE_SIGN',
  ASSET_PLEDGE: 'ASSET_PLEDGE',
  DSP_KFS: 'DSP_KFS',
  CREDIT_LOADING: 'CREDIT_LOADING',
  APPLICATION_PENDING_BLOCKING_SCREEN: 'APPLICATION_PENDING_BLOCKING_SCREEN',
  DIGIO_AUTOPAY_INPROGRESS: 'DIGIO_AUTOPAY_INPROGRESS',
  SIGN_DESK_ESIGN: 'SIGN_DESK_ESIGN',
  MFC_FETCH_EVALUTE_FUNDS: 'MFC_FETCH_EVALUTE_FUNDS',
  MFC_FETCH_LANDING: 'MFC_FETCH_LANDING',
  MFC_FETCH_ANCHOR: 'MFC_FETCH_ANCHOR',
  KYC_STEPPER: 'KYC_STEPPER',
  BLOCKED: 'BLOCKED',
  // CHECK_CUSTOMER_ELIGIBILITY: 'CHECK_CUSTOMER_ELIGIBILITY',
  // MF_FETCH_PORTFOLIO: 'MF_FETCH_PORTFOLIO',
  // MF_PLEDGE_PORTFOLIO: 'MF_PLEDGE_PORTFOLIO',
  // KYC_DOCUMENTS: 'KYC_DOCUMENTS',
  // KYC_ADDITIONAL_DETAILS: 'KYC_ADDITIONAL_DETAILS',
  // KYC_SUMMARY: 'KYC_SUMMARY',
  // KYC_PHOTO_VERIFICATION: 'KYC_PHOTO_VERIFICATION',
  // BANK_ACCOUNT_VERIFICATION: 'BANK_ACCOUNT_VERIFICATION',
  // TATA_MANDATE: 'TATA_MANDATE',
  // ASSET_PLEDGE: 'ASSET_PLEDGE',
  // SIGN_DESK_ESIGN: 'SIGN_DESK_ESIGN',
  HOME: 'HOME',
  USER_PROFILE: 'USER_PROFILE',
  ABOUT_US: 'ABOUT_US',
  WEBVIEW_SCREEN: 'WEBVIEW_SCREEN',
  LENDING_PARTNERS: 'LENDING_PARTNERS',
  PRODUCT_DETAILS: 'PRODUCT_DETAILS',
  CONTACT_US: 'CONTACT_US',
  GET_STARTED: 'GET_STARTED',
  PLEDGE_CONFIRMATION: 'PLEDGE_CONFIRMATION',
  STATE_SELECTION: 'STATE_SELECTION',
  MF_FETCH_PORTFOLIO: 'MF_FETCH_PORTFOLIO',
  CHECKING_LIMIT: 'CHECKING_LIMIT',
  UNLOCK_LIMIT_LANDING: 'UNLOCK_LIMIT_LANDING',
  MF_PLEDGE_PORTFOLIO: 'MF_PLEDGE_PORTFOLIO',
  PORTFOLIO_FROM_RTA: 'PORTFOLIO_FROM_RTA',
  SET_CREDIT_LIMIT: 'SET_CREDIT_LIMIT',
  PORTFOLIO: 'PORTFOLIO',
  LOAN_OFFER_ENHANCE_LIMIT: 'LOAN_OFFER_ENHANCE_LIMIT',
  CHECK_CUSTOMER_ELIGIBILITY: 'CHECK_CUSTOMER_ELIGIBILITY',
  CIBIL_CHECK_LOADING_SCREEN: 'CIBIL_CHECK_LOADING_SCREEN',
  WITHDRAW_AMOUNT: 'WITHDRAW_AMOUNT',
  CONFIRM_WITHDRAW_AMOUNT: 'CONFIRM_WITHDRAW_AMOUNT',
  WITHDRAW_SUCCESS: 'WITHDRAW_SUCCESS',
  FLEXI_PAY: 'FLEXI_PAY',
  CONFIRM_PAYMENT_DETAILS: 'CONFIRM_PAYMENT_DETAILS',
  INTEREST_PAYMENT: 'INTEREST_PAYMENT',
  INTEREST_LEARN_MORE: 'INTEREST_LEARN_MORE',
  SHORTFALL_DETAILS: 'SHORTFALL_DETAILS',
  SHORTFALL_REPAY: 'SHORTFALL_REPAY',
  WHAT_IS_SHORTFALL: 'WHAT_IS_SHORTFALL',
  SHOTFALL_LEARN_MORE: 'SHOTFALL_LEARN_MORE',
  RENEW_LOAN: "RENEW_LOAN",
  RENEWAL_LEARN_MORE: 'RENEWAL_LEARN_MORE',
  VERIFY_RENEW_LOAN: "VERIFY_RENEW_LOAN",
  RENEWAL_STATUS: 'RENEWAL_STATUS',
  PAYMENT_STATUS: 'PAYMENT_STATUS',
  PAYMENT_WEBVIEW: 'PAYMENT_WEBVIEW',
  PLEADGE_MF: 'PLEADGE_MF',
  PLEDGE_MORE: 'PLEDGE_MORE',
  REMOVE_PLEGE: 'REMOVE_PLEGE',
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  LOAN_DETAILS: 'LOAN_DETAILS',
  LOAN_CLOSURE: 'LOAN_CLOSURE',
  UPDATE_PHONE_EMAIL: 'UPDATE_PHONE_EMAIL',
  PLEDGE_HISTORY: 'PLEDGE_HISTORY',
  HOW_TO_CLOSE_ACCOUNT: 'HOW_TO_CLOSE_ACCOUNT',
  OLD_FORECLOSURE: 'OLD_FORECLOSURE',
  REPAY_DUES: 'REPAY_DUES',
  SELECT_CLOSE_REASON: 'SELECT_CLOSE_REASON',
  CONFIRM_LOAN_DETAILS: 'CONFIRM_LOAN_DETAILS',
  UNPLEDGE_INSTRUCTIONS: 'UNPLEDGE_INSTRUCTIONS',
  PLEDGE_DETAILS: "PLEDGE_DETAILS",
  ELEVATE_LANDING: 'ELEVATE_LANDING',
  ELEVATE_SWITCHING: 'ELEVATE_SWITCHING',
  UPDATE_ACCOUNT_SUCCESS: 'UPDATE_ACCOUNT_SUCCESS',
  HELP_AND_SUPPORT_SCREEN_REVAMP: 'HELP_AND_SUPPORT_SCREEN_REVAMP',
  FAQ_SCREEN_REVAMP: 'FAQ_SCREEN_REVAMP',
  FAQ_DETAILS_SCREEN_REVAMP: 'FAQ_DETAILS_SCREEN_REVAMP',
  VIEW_DETAILS: 'VIEW_DETAILS',
  MANAGE_LIMIT_LANDING: 'MANAGE_LIMIT_LANDING',
  MFD_SHARE_LINK_INIT: 'MFD_SHARE_LINK_INIT',
  MFD_SHARE_LINK_END_JOURNEY: 'MFD_SHARE_LINK_END_JOURNEY',
  MFD_SHARE_LINK_INIT_AUTH: 'MFD_SHARE_LINK_INIT_AUTH',
  REDIRECTION_JOURNEY_SCREEN: 'REDIRECTION_JOURNEY_SCREEN',
  PAYMENT_LOADER: "PAYMENT_LOADER",
  BAJAJ_SHUTDOWN: "BAJAJ_SHUTDOWN",
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  VIEW_ALL_LOANS: "VIEW_ALL_LOANS",
  REWARDS_SCREEN: "REWARDS_SCREEN",
  REFERRAL_DASHBOARD: "REFERRAL_DASHBOARD"
} as const;

export default ROUTE;
